import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ClipboardText } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";

const RESPONSES = {
  done: "Logged 💪 I'll build on it today.",
  partial: "Noted — partly counts too.",
  skipped: "No guilt — I'll make today easier to start.",
};

export default function FeedbackPrompt({ prompt, onDone }) {
  const [busy, setBusy] = useState(false);
  if (!prompt) return null;

  const send = async (status) => {
    if (busy) return;
    setBusy(true);
    try {
      await api.post("/plan-feedback", { date: prompt.date, status });
      if (RESPONSES[status]) toast.success(RESPONSES[status]);
      onDone?.();
    } catch {
      toast.error("Couldn't save that — try again?");
      setBusy(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, height: 0 }}
        data-testid="feedback-prompt"
        className="clay p-5 mb-6 flex flex-wrap items-center gap-3"
      >
        <div className="w-10 h-10 rounded-2xl bg-sage/15 flex items-center justify-center shrink-0">
          <ClipboardText size={19} weight="fill" color="#16BC9C" />
        </div>
        <div className="flex-1 min-w-[180px]">
          <p className="font-medium text-[15px]">Quick one — did yesterday happen?</p>
          {prompt.plan_title && <p className="text-sm text-muted2 mt-0.5">"{prompt.plan_title}"</p>}
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="feedback-done-btn" onClick={() => send("done")}
            className="rounded-full bg-sage text-white px-4 py-2 text-sm font-medium hover:opacity-90 transition-opacity">
            Did it ✓
          </button>
          <button data-testid="feedback-partial-btn" onClick={() => send("partial")}
            className="rounded-full bg-secondary px-4 py-2 text-sm font-medium hover:bg-border transition-colors">
            Partly
          </button>
          <button data-testid="feedback-skipped-btn" onClick={() => send("skipped")}
            className="rounded-full bg-secondary px-4 py-2 text-sm font-medium hover:bg-border transition-colors">
            Skipped
          </button>
        </div>
        <button data-testid="feedback-dismiss-btn" onClick={() => send("dismissed")} title="Dismiss"
          className="w-7 h-7 rounded-full hover:bg-secondary flex items-center justify-center shrink-0 transition-colors">
          <X size={15} weight="bold" color="#7C8AA5" />
        </button>
      </motion.div>
    </AnimatePresence>
  );
}
